
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/test-series/[slug]/[courseUID]",
      function () {
        return require("private-next-pages/store/test-series/[slug]/[courseUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/test-series/[slug]/[courseUID]"])
      });
    }
  